/**
 * SavedBy checkout remount helper for Horizon cart drawer.
 *
 * Problem: SavedBy injects <savedby-checkout-plus> next to #checkout on first
 * scan. Horizon morphs cart HTML after ATC / qty changes and replaces the
 * summary with server HTML (native #checkout only), wiping SavedBy's widget
 * until a full page refresh.
 *
 * Fix: after cart updates / drawer open, if #checkout exists without
 * savedby-checkout-plus, nudge the DOM so SavedBy's observer can remount.
 */
(function () {
  if (window.__brightsideSavedByRemountBound) return;
  window.__brightsideSavedByRemountBound = true;

  var remountTimer = null;

  function findCheckoutHosts() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.cart__ctas, [data-savedby-checkout-host] .cart__ctas')
    );
  }

  function needsRemount(ctas) {
    if (!ctas) return false;
    var checkout = ctas.querySelector('#checkout, [name="checkout"]');
    if (!checkout) return false;
    return !ctas.querySelector('savedby-checkout-plus');
  }

  function trySavedByApis() {
    var api =
      window.SavedBy ||
      window.savedby ||
      window.SavedByCheckout ||
      window.savedByCheckoutPlus;

    if (!api) return false;

    var methods = ['refresh', 'remount', 'reinit', 'init', 'update', 'render'];
    for (var i = 0; i < methods.length; i++) {
      var name = methods[i];
      if (typeof api[name] === 'function') {
        try {
          api[name]();
          return true;
        } catch (e) {
          /* try next */
        }
      }
    }
    return false;
  }

  function nudgeCheckoutNode(ctas) {
    var checkout = ctas.querySelector('#checkout, [name="checkout"]');
    if (!checkout || !checkout.parentNode) return;

    // Re-insert the checkout button so MutationObservers re-scan.
    var parent = checkout.parentNode;
    var marker = document.createComment('savedby-remount');
    parent.insertBefore(marker, checkout);
    parent.removeChild(checkout);
    parent.insertBefore(checkout, marker);
    parent.removeChild(marker);

    // Touch attributes SavedBy may watch.
    checkout.setAttribute('data-savedby-remount', String(Date.now()));
  }

  function remountSavedByCheckout() {
    var hosts = findCheckoutHosts();
    var nudged = false;

    hosts.forEach(function (ctas) {
      if (!needsRemount(ctas)) return;
      nudgeCheckoutNode(ctas);
      nudged = true;
    });

    if (nudged) {
      trySavedByApis();
      document.dispatchEvent(new CustomEvent('savedby:remount', { bubbles: true }));
    }
  }

  function scheduleRemount(delay) {
    if (remountTimer) window.clearTimeout(remountTimer);
    remountTimer = window.setTimeout(function () {
      remountTimer = null;
      remountSavedByCheckout();
      // Second pass — SavedBy scripts sometimes init slightly later.
      window.setTimeout(remountSavedByCheckout, 400);
      window.setTimeout(remountSavedByCheckout, 1200);
    }, typeof delay === 'number' ? delay : 150);
  }

  document.addEventListener('cart:update', function () {
    scheduleRemount(200);
  });

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (
        target.closest('[data-testid="cart-drawer-trigger"]') ||
        target.closest('.header-actions__cart-icon') ||
        target.closest('cart-drawer-component button[aria-haspopup="dialog"]')
      ) {
        scheduleRemount(300);
      }
    },
    true
  );

  // When drawer dialog opens
  document.addEventListener(
    'toggle',
    function (event) {
      var dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement)) return;
      if (!dialog.classList.contains('cart-drawer__dialog')) return;
      if (dialog.open) scheduleRemount(250);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleRemount(500);
    });
  } else {
    scheduleRemount(500);
  }

  window.__brightsideRemountSavedByCheckout = remountSavedByCheckout;
})();
